/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Key_PlaceholderInputs */

const en_byoa_key_placeholder = /** @type {(inputs: Byoa_Key_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your AI key here`)
};

const id_byoa_key_placeholder = /** @type {(inputs: Byoa_Key_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempel kunci AI-mu di sini`)
};

/**
* | output |
* | --- |
* | "Paste your AI key here" |
*
* @param {Byoa_Key_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_key_placeholder = /** @type {((inputs?: Byoa_Key_PlaceholderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Key_PlaceholderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_key_placeholder(inputs)
	return en_byoa_key_placeholder(inputs)
});